import { Component } from '@angular/core';
import { HttpService } from '../../http.service';

@Component({
  selector: 'app-setting-user',
  templateUrl: './setting-user.component.html',
  styleUrls: ['./setting-user.component.scss']
})
export class SettingUserComponent {

  public users: any = [];
  public selected_company: any = null;
  public existing_username: string = '';

  constructor(private http: HttpService) { 
    this.getList();
    this.selected_company = this.http.getStaticSelectedCompany();
  }


  async getList() {
    const res:any = await this.http.post('/admin/user/list');
    this.users = res.users;
  }

  editUser(id: number) {
    console.log(id);
  }

  async deleteUser(uuid: string) {
    let y = confirm('Are you sure you want to delete this user?');
    if(!y) {
      return;
    }
    await this.http.post('/admin/user/delete-from-company', {existing_user_uuid: uuid})
    await this.getList();
  } 

  async addExistingUser() {

    if(!this.existing_username) {
      this.http.toast('Please enter a username', 'error');
      return;
    }

    const res:any = await this.http.post('/admin/user/add-existing', {username: this.existing_username});

    if(res.status) {
      this.getList();
      this.existing_username = '';
    }

    if(!res.status && res.message) {
      this.http.toast(res.message, 'error');
    }
  }

}
